import Services from "./index.service";

import buildQuery from "odata-query";

import { IRequestConfig } from "models/Axios";
import {
  IQuoteBionexoMappingData,
  IQuoteBionexoMapping,
} from "models/QuoteBionexoMapping";
import { IQuoteBionexo } from "models/QuoteBionexo";
import { IOption } from "components/Select/interface";
import { IQuotes } from "models/Quote";
import qs from "qs";
import { formatISO } from "date-fns";
export default class QuoteBionexoMappingSevices extends Services<
  IQuoteBionexoMappingData,
  IQuoteBionexoMapping
> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  getQuotationExpiredNotAnswered = (
    currentPage?: number,
    pageSize?: number,
    sellerCodes?: string[],
    productCategories?: string[],
    businessUnitIdentifier?: string[],
    startDate?: Date,
    endDate?: Date,
    code?: string,
    origin?: string,
    crmCustomerCode?: string,
    buyerName?: string,
    statusViveo?: string[],
    statusBionexo?: string[]
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quote-unanswered-expired`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
      params: {
        top: `${top}`,
        skip: `${skip * top}`,
        sellerCodes,
        productCategories: productCategories,
        businessUnitIdentifier,
        startDate,
        endDate,
        code,
        origin,
        crmCustomerCode,
        buyerName,
        statusViveo,
        statusBionexo
      },
    };

    return this.httpRequest(config);
  };

  getMoneyRecordedQuotations = (
    currentPage?: number,
    pageSize?: number,
    sellerCodes?: string[],
    productCategories?: string[],
    businessUnitIdentifier?: string[],
    startDate?: Date,
    endDate?: Date,
    code?: string,
    origin?: string,
    crmCustomerCode?: string,
    buyerName?: string,
    statusViveo?: string[],
    statusBionexo?: string[],
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quote-saved-waiting-to-be-sent`,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        top,
        skip: `${skip * top}`,
        sellerCodes,
        productCategories: productCategories,
        businessUnitIdentifier,
        startDate,
        endDate,
        code,
        origin,
        crmCustomerCode,
        buyerName,
        statusViveo,
        statusBionexo,
      },
    };

    return this.httpRequest(config);
  };

  getQuotesWaitingFeedback = (
    currentPage?: number,
    pageSize?: number,
    sellerId?: string[],
    productCategories?: string[],
    businessUnit?: string[],
    startDate?: Date | undefined,
    endDate?: Date | undefined
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quote-answered-waiting-reply-customer`,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        sellerId,
        productCategories: productCategories,
        businessUnit,
        startDate: startDate ? formatISO(startDate) : null,
        endDate: endDate ? formatISO(endDate) : null,
      },
    };

    return this.httpRequest(config);
  };

  getQuotesWaitingRecording = (
    currentPage?: number,
    pageSize?: number,
    sellerCode?: string[],
    productCategories?: string[],
    businessUnitIdentifier?: string[],
    startDate?: Date,
    endDate?: Date
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;

    const config: IRequestConfig<IQuoteBionexo> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quote-waiting-recording`,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        sellerCode,
        productCategories: productCategories,
        businessUnitIdentifier,
        startDate: startDate ? formatISO(startDate) : null,
        endDate: endDate ? formatISO(endDate) : null,
      },
    };

    return this.httpRequest(config);
  };

  getProductOutPortfolio = (
    currentPage?: number,
    pageSize?: number,
    sellerId?: string[],
    productCategories?: string[],
    businessUnit?: string[],
    startDate?: Date,
    endDate?: Date
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const config: IRequestConfig<IQuotes> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/quote-items-out-of-portfolio`,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat" }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        sellerId,
        productCategories: productCategories,
        businessUnit,
        startDate: startDate ? formatISO(startDate) : null,
        endDate: endDate ? formatISO(endDate) : null,
      },
    };

    return this.httpRequest(config);
  };

  getSubsidiaries = () => {
    const config: IRequestConfig<IOption> = {
      baseUrl: this.base_url,
      url: `/business-units`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $filter:
          "identifier eq 'CON' or identifier eq 'SUL' or identifier eq 'SPC' or identifier eq 'SPI' or identifier eq 'ONCO' or identifier eq 'REDES' or identifier eq 'SUD' or identifier eq 'NE1' or identifier eq 'NE2' or identifier eq 'OPER' or identifier eq 'GOV1' or identifier eq 'GOV2' or identifier eq 'MC' ",
        $top: 50,
        $orderby: "name asc"
      },
    };

    return this.httpRequest(config);
  };

  getMoneyBusinessUnits = () => {
    const config: IRequestConfig<IOption> = {
      baseUrl: this.mafraq_url,
      url: `/business-unit`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: 50,
        $orderby: "name asc"
      },
    };

    return this.httpRequest(config);
  };

  getSellers = (businessUnits?: string[]) => {
    const config: IRequestConfig<IOption> = {
      baseUrl: this.base_url,
      url: `/seller/seller-by-business-unit`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
      params: {
        businessUnits,
      },
    };

    return this.httpRequest(config);
  };

  getSellerByBusinessUnit = (businessUnit: string[]) => {
    const config: IRequestConfig<IOption> = {
      baseUrl: this.mafraq_url,
      url: `/Seller/by-business-unit/${businessUnit}`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return this.httpRequest(config);
  };

  getCategories = () => {
    const config: IRequestConfig<IOption> = {
      baseUrl: this.mafraq_url,
      url: `/Category`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
      params: {
        $top: 100,
      },
    };

    return this.httpRequest(config);
  };

  getItemsOutOfStock = (
    currentPage?: number,
    pageSize?: number,
    filter?: any
  ) => {
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<IQuotes> = {
      baseUrl: this.mafraq_url,
      url: `/Quotation/items/out-of-stock${filterQuery}`,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return this.httpRequest(config);
  };
}
